export default "__VITE_ASSET__kFwJCk6O__"